import { useState , useEffect } from 'react';
import { decodeStorage, removeStorage } from 'functions/storageBase64';
import { useStore } from 'store'
import { setGiftTable } from 'store/actions/giftTable'
import useExternalLinnk from 'newHooks/useExternalLinnk';
import ModalProductTC from '../../Modal'
import styles from '../styles.module.sass'
import ProductsResp from '../ProductResponse';
import ProductsSuccessAdd from '../ProductSuccessAdd';

const ProductAddTable = () => {

    const isMobile = 'desktop'
    const searsProduct = decodeStorage('sears-product')
    const { handleID, setResetResponse, responseProduct, responseError } = useExternalLinnk()

    const [listOfGiftsTables, dispatch] = useStore( (state) => state.giftTable.myListOfGiftsTables.results.list )

    const [ title, ] = useState('Artículo agregado')

    const [ showModal, setShowModal ] = useState(false)
    const [errorProduct, setErrorProduct] = useState(false)
    const [ giftUrl, setGiftUrl ] = useState(null)
    const [ idProduct, setIdPRoduct ] = useState(null)
    const [ showModalTable, setShowModalTable ] = useState(false)
    const [ changeTable, setChangeTable ] = useState(false)
    const [ listOfTables, setListOfTables ] = useState(null)


    const handleClose = () => {
        setShowModalTable(false)
    }

    useEffect(()=>{
        if(listOfGiftsTables){
            if(listOfGiftsTables?.length >= 1){
                const listTables = listOfGiftsTables?.filter(tables => tables?.estatus === 'Open')
                setListOfTables(listTables)
            }
        }
    },[ listOfGiftsTables])

    useEffect(()=>{
        if(searsProduct){
            if(listOfTables){
                if(listOfTables?.length > 1){
                    setShowModalTable(true)
                }
                else if(listOfTables?.length === 1){
                    setGiftUrl(searsProduct)
                }else{
                    setShowModalTable(false)
                }
            }
        }
    },[searsProduct, listOfTables])


    useEffect(()=>{
        if(changeTable){
            // console.log('changeTable: ',changeTable)
            dispatch(setGiftTable(changeTable))
            setTimeout(()=>{
                setShowModalTable(false)
                setGiftUrl(searsProduct)
            },700)
        }
    },[changeTable])


    /* */
    const resettUrl = () => {
        setGiftUrl(null)
        setIdPRoduct(null)
        setErrorProduct(false)
        removeStorage('sears-product')
        setResetResponse()
    }

    useEffect(()=>{
        if(responseProduct){
            setShowModal(true)
        }else if(responseError){
            setErrorProduct(true)
        }
    },[responseProduct, responseError])

    useEffect(()=>{
        if(giftUrl){
            if(giftUrl.indexOf('producto') >= 0){
                try{
                    const id = giftUrl.split('producto')[1].split('/')[1]
                    setIdPRoduct(id)
                }catch(e){
                    setIdPRoduct(null)
                }
            }
        }
    },[giftUrl])

    useEffect(()=>{
        if(idProduct){
            handleID(idProduct)
        }
    },[idProduct])

    return(
        <>
            {showModalTable
                ? 
                    <ModalProductTC
                        onClose={handleClose} 
                        isMobile={isMobile} 
                        type={isMobile === 'desktop' ? '' : 'full'} 
                        title={title} 
                        closeBody="modalPromos"
                    >
                        <ModalChangeTable 
                            listOfTables={listOfTables}
                            handleClose={handleClose}
                            setChangeTable={setChangeTable}
                        />
                    </ModalProductTC>
                : null
            }
            {responseProduct?.length >= 1
                ? <ProductsResp item={responseProduct[0]} showModal={showModal} resettUrl={resettUrl} />
                : null 
            }
            {errorProduct
                ?
                    <ProductsSuccessAdd
                        errorProduct={errorProduct}
                        setErrorProduct={setErrorProduct}
                        resettUrl={resettUrl}
                    />
                : null
            }
        </>
    )
}

const ModalChangeTable = (props) => {
    const {
        listOfTables,
        handleClose,
        setChangeTable
    } = props


    const [ indexTable, setIndexTable ] = useState(false)
    const handleChange = (event) => {
        const { value } = event.target
        setIndexTable(value)
    }

    const handleAcept = () => {
        const tableAcepted = listOfTables[indexTable]
        setChangeTable(tableAcepted)
    }

    return(
        <div className={styles?.successModalProduct}>
            <div onClick={handleClose} className={styles?.closeBtn} aria-hidden >X</div>
            <p className={styles?.title}>Selecciona una mesa de regalos</p>
                <div className={styles?.contSelect}>
                    <select className={styles?.select} onChange={handleChange}>
                        <option selected disabled>Selecciona una mesa de regalos</option>
                            {listOfTables?.length > 1
                                ?
                                listOfTables.map((item, index) => (
                                    <option key={item?.id} value={index}>#{item?.evento}</option>
                                ))
                                :null
                            }
                    </select>
                </div>
            <div onClick={handleAcept} className={`btn primaryButton ${styles?.btnprimary}`} aria-hidden>Aceptar</div>
        </div>
    )
}

export default ProductAddTable